import {
  ERPSeedless,
  ERPRJL
} from "src/utils/constants";
import { IRoute } from "src/pages/Router/routes";

import UserSettingsPage from "./UserSettingsPage";
import UserSmartSettingsPage from "./UserSmartSettingsPage";

export const CustomerSettings: IRoute[] = [
  {
    exact: true,
    path: "/settings/user",
    pageComponent: UserSettingsPage,
    title: "%USER% Settings",
    allowedContexts: [ "LIST_PRODUCT_SELECTION" ],
    menuType: "MAIN",
    roles: [ "customer" ],
    hidden: true,
    privateRoute: true
  },
  {
    exact: true,
    path: "/smart-settings/user",
    pageComponent: UserSmartSettingsPage,
    title: "Smart Settings",
    menuType: "MAIN",
    roles: [ "customer" ],
    hidden: true,
    privateRoute: true
  }
];

export default CustomerSettings;
